enum ProcedureDisplayType {
  NORMAL = 'NORMAL',
  MULTI_RECORD = 'MULTI_RECORD',
  GRID = 'GRID',
}

export default ProcedureDisplayType;
